import { createFileRoute } from "@tanstack/react-router";

import { Join } from "@/features/join";

export const Route = createFileRoute("/(member)/(public)/join")({
  component: Join,
  head: () => ({
    meta: [
      { title: "Birdwatch - Join" },
      { name: "description", content: "Birdwatch - Join" },
    ],
  }),
});
